<div class="layout-footer">
    Powered by
    <a href="https://lionsys.com.py" target="_blank" rel="noopener noreferrer"
        class="text-primary font-bold hover:underline"><span>&copy;
            {{year}} JACA TECH</span> </a>
</div>